import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import store from '../store'
import translation_en from './en.json';
import translation_zh from './zh.json';
import translation_kr from './kr.json';
import translation_rr from './rr.json';
import translation_in from './in.json';
import translation_jp from './jp.json';

const resources = {
    en: {
        translation: translation_en,
    },
    zh: {
        translation: translation_zh,
    },
    kr: {
        translation: translation_kr,
    },
    rr: {
        translation: translation_rr,
    },
    in: {
        translation: translation_in,
    },
     jp: {
        translation: translation_jp,
    },
};

 const lan = localStorage.getItem("lan") || "en"
// const lan = "zh"
store.dispatch({type:'setLan',value:lan})

i18n.use(initReactI18next).init({
    resources,
    lng: lan,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
